// We typically rely on the TRELLO_ORIGIN variable in /conf files to use for the Power-Up's
// targetOrigin depending on the environment (dev, staging, and prod). However, we want to detect
// special devserver environments and make sure we are setting the right targetOrigin for those too.
function getTargetOrigin() {
  const devserverOrigins = 'undefined';
  if (devserverOrigins?.split(',').includes(document?.referrer)) {
    return document.referrer;
  }
  return 'https://trello.com';
}

module.exports = {
  getTargetOrigin,
};
